module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-schreibtisch-04.54eddeb2.jpeg";